/**
 * Schedule helper: stored values are recipient wall-clock
 * ({ hour, dayOfWeek, dayOfMonth, month } = local clock face for each user).
 * Do not convert admin browser time to UTC on save.
 */

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/**
 * Format wall-clock schedule for CMS display (no UTC conversion).
 * @param {Array<{label:string,value:number}>} [dayOfWeekOptions]
 * @param {number} [month] Yearly only: 0=January … 11=December
 */
export function formatWallClockSchedule(
  period,
  hour,
  dayOfWeek,
  dayOfMonth,
  dayOfWeekOptions,
  month,
) {
  const hourStr = `${String(hour ?? 0).padStart(2, '0')}:00`;
  if (period === 'daily') return hourStr;
  if (period === 'weekly' && dayOfWeek !== undefined && dayOfWeek !== null) {
    const label = dayOfWeekOptions?.find((o) => o.value === dayOfWeek)?.label
      ?? DAY_NAMES[dayOfWeek];
    return `${label} ${hourStr}`;
  }
  if (period === 'monthly' && dayOfMonth !== undefined && dayOfMonth !== null) {
    return `${dayOfMonth}. ${hourStr}`;
  }
  if (period === 'yearly' && dayOfMonth !== undefined && dayOfMonth !== null) {
    const monthLabel = MONTH_NAMES[month ?? 0] ?? MONTH_NAMES[0];
    return `${monthLabel} ${dayOfMonth}. ${hourStr}`;
  }
  return hourStr;
}